import styled from 'styled-components';
import { BreakPoints } from '@makemydeal/dr-ui-bricks-utils';

export const DealProposalContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 30px;
`;

export const HeaderRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 12px;

    @media (max-width: ${BreakPoints.PHONE}) {
        flex-direction: column;
        align-items: stretch;
    }
`;

export const ActionBar = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 12px;

    @media (max-width: ${BreakPoints.PHONE}) {
        flex-direction: column-reverse;
        align-items: stretch;
    }
`;
